import { Store } from '@ngrx/store';
import { DatiUIU } from './model/dati-uiu.model';
import * as DatiUIUActions from './store/actions/dati-uiu.actions';
import { Component, OnInit } from '@angular/core';
import { AppState } from './app.state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  token: string;
  filename: string;

  constructor(
    private store: Store<AppState>
  ) {}
  
  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.filename = localStorage.getItem('planimetrie') === 'undefined' ? undefined : localStorage.getItem('planimetrie');
    const datiUIU: DatiUIU = {
      sezione: localStorage.getItem('sezione'),
      foglio: localStorage.getItem('foglio'),
      numero: localStorage.getItem('numero'),
      subalterno: localStorage.getItem('subalterno'),
      superficieDpr: localStorage.getItem('superficieDpr')
    };
    this.store.dispatch(new DatiUIUActions.SetDatiUiu(datiUIU));
  }

}
